import {
  formatHoursUsed,
  formatHoursQuota,
  isBelowStartThreshold,
  remainingSeconds,
  MIN_SESSION_START_SECONDS,
} from '../../lib/usage.js'

const PLAN_LABELS = {
  decouverte: 'Découverte',
  cabinet: 'Cabinet',
  cabinet_pro: 'Cabinet Pro',
}

// Round MIN_SESSION_START_SECONDS to a minute count for the user-facing
// copy. 300 s → "5 minutes". If the threshold changes to a non-round
// value, update this format accordingly.
const MIN_MINUTES = Math.round(MIN_SESSION_START_SECONDS / 60)

function formatMinutesRemaining(seconds) {
  const m = Math.max(0, Math.floor(seconds / 60))
  if (m === 0) return 'moins d’une minute'
  if (m === 1) return '1 minute'
  return `${m} minutes`
}

export default function OverQuotaModal({ usage, onClose }) {
  const planLabel = PLAN_LABELS[usage?.plan] || 'Plan actuel'
  const quota = formatHoursQuota(usage?.monthly_seconds_quota)
  const used = formatHoursUsed(usage?.monthly_seconds_used)
  const belowThreshold = isBelowStartThreshold(usage)
  const remainingLabel = formatMinutesRemaining(remainingSeconds(usage))

  // Two branches: truly out of time vs. some left but below the
  // 5-minute floor required to start a session. The upsell rows are
  // shared because the user's path forward is the same either way.
  const title = belowThreshold ? 'Temps insuffisant pour démarrer une séance' : 'Limite mensuelle atteinte'
  const body = belowThreshold ? (
    <>
      Il vous reste <strong>{remainingLabel}</strong> sur votre plan <strong>{planLabel}</strong> ({used} / {quota}).
      Démarrer une séance nécessite au moins {MIN_MINUTES} minutes restantes.
      La limite se réinitialise le 1er du mois prochain.
    </>
  ) : (
    <>
      Votre plan <strong>{planLabel}</strong> autorise {quota} d&apos;enregistrement par mois.
      Vous en avez utilisé {used} / {quota}.
      La limite se réinitialise le 1er du mois prochain.
    </>
  )

  return (
    <div role="dialog" aria-modal className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-2xl border border-terra-500/40 bg-white p-5 shadow-xl sm:p-7">
        <h2 className="text-[18px] font-semibold tracking-[-0.02em]">{title}</h2>
        <p className="mt-2 text-[13px] text-muted">{body}</p>
        <ul className="mt-5 space-y-2">
          <li className="flex items-center justify-between gap-2 rounded-lg border border-line bg-bg px-3 py-3 sm:px-4">
            <span className="text-[13.5px]">Cabinet</span>
            <span className="text-[12.5px] text-muted">30 h/mois · 90 j rétention</span>
          </li>
          <li className="flex items-center justify-between gap-2 rounded-lg border border-line bg-bg px-3 py-3 sm:px-4">
            <span className="text-[13.5px]">Cabinet Pro</span>
            <span className="text-[12.5px] text-muted">100 h/mois · 365 j rétention</span>
          </li>
        </ul>
        <div className="mt-6 flex justify-end">
          <button onClick={onClose} className="rounded-lg bg-ink px-4 py-2 text-[13px] font-medium text-white">
            Retour aux séances
          </button>
        </div>
      </div>
    </div>
  )
}
